import { IRootState } from '..';

export const SELECTOR_PLAYER_ERROR = (state: IRootState) => state.PlayerError.error;
